<script lang="ts">

    export let percentage: number;
    export let id: number;


</script>

<div data-fill={percentage} class="star">
    <svg viewBox="0 0 51 48" class="svg" width="10px" height="10px">
        <defs>
            <linearGradient id={`widgetGrad-${id}`} x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset={"0%"} class="filled"/>
                <stop offset={`${percentage}%`} class="filled"/>
                <stop offset={`${percentage}%`} class="empty"/>
                <stop offset={'100%'} class="empty"/>
            </linearGradient>
        </defs>
        <path d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z" fill={`url('#widgetGrad-${id}')`}/>
    </svg>
</div>

<!--suppress CssUnresolvedCustomProperty -->
<style>

    .filled {
        stop-color: #ffd700;
        stop-opacity: 1;
    }

    .empty {
        stop-color: #ccc;
        stop-opacity: 1;
    }

    .svg {
        transition: transform 0.2s ease-in-out 0s;
    }

    .star {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        padding-right: 2px;
    }

</style>